import axiosApi from 'modules/api'
import { VerifyAuthOrderResponse } from 'pages/api/orders/[orderId]/verify'

const verifyPrivateOrder = async (
  orderId: string
): Promise<VerifyAuthOrderResponse> => {
  const { data } = await axiosApi.get<VerifyAuthOrderResponse>(
    `/orders/${orderId}/verify`
  )
  return data
}

export default verifyPrivateOrder
